/**
 * DashboardWidget.tsx - DashboardWidget - Individual dashboard widget
 * 
 * CHANGE HISTORY:
 * - 251021_0438 [46df53c] danielbeer: feat: complete comprehensive package migration to full standards
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';

const DashboardWidget = ({ widget, metrics, isSelected, isEditMode, onSelect }) => {
  const renderContent = () => {
    switch (widget.type) {
      case 'kpi':
        return (
          <div className="widget-kpi">
            <div className="widget-kpi-value">{metrics.totalItems}</div>
            <div className="widget-kpi-label">{widget.title}</div>
          </div>
        );
      
      case 'pie':
        const statusData = Object.entries(metrics.statusCounts);
        return (
          <div className="widget-chart">
            <h4>{widget.title}</h4>
            <div className="widget-pie-chart">
              {statusData.map(([status, count]) => (
                <div key={status} className="widget-pie-item">
                  <div className="widget-pie-bar" style={{ width: `${(count / metrics.totalItems) * 100}%` }} />
                  <div className="widget-pie-label">
                    {status}: {count}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      
      case 'line':
        const timelineData = Object.entries(metrics.itemsByDay);
        const maxValue = Math.max(...Object.values(metrics.itemsByDay), 1);
        return (
          <div className="widget-chart">
            <h4>{widget.title}</h4>
            <div className="widget-line-chart">
              {timelineData.map(([day, count]) => (
                <div key={day} className="widget-line-bar">
                  <div
                    className="widget-line-bar-fill"
                    style={{ height: `${(count / maxValue) * 100}%` }}
                  />
                  <div className="widget-line-label">{day.split(' ')[1]}</div>
                </div>
              ))}
            </div>
          </div>
        );
      
      case 'progress':
        return (
          <div className="widget-progress">
            <h4>{widget.title}</h4>
            <div className="widget-progress-circle">
              <svg viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="40" fill="none" stroke="var(--border-light)" strokeWidth="8" />
                <circle
                  cx="50"
                  cy="50"
                  r="40"
                  fill="none"
                  stroke="#4f46e5"
                  strokeWidth="8"
                  strokeDasharray={`${metrics.completionRate * 2.51} 251`}
                  transform="rotate(-90 50 50)"
                />
              </svg>
              <div className="widget-progress-value">{metrics.completionRate}%</div>
            </div>
            <div className="widget-progress-label">Completion Rate</div>
          </div>
        );
      
      default:
        return (
          <div className="widget-placeholder">
            <div>{widget.title}</div>
            <div className="widget-placeholder-type">{widget.type}</div>
          </div>
        );
    }
  };
  
  return (
    <div
      className={`dashboard-widget ${isSelected ? 'selected' : ''} ${isEditMode ? 'edit-mode' : ''}`}
      onClick={onSelect}
    >
      {renderContent()}
      
      {isEditMode && (
        <div className="widget-edit-handle">
          ⋮⋮
        </div>
      )}
    </div>
  );
};

export default DashboardWidget;
